import React from 'react';
import { Search, Wheat, Heart, TrendingUp } from 'lucide-react';
import { operationsData } from '../data/mock';

const iconMap = {
  Search: Search,
  Wheat: Wheat,
  Heart: Heart,
  TrendingUp: TrendingUp,
};

const OperationsSection = () => {
  return (
    <section id="operations" className="py-24 md:py-32 bg-white">
      <div className="container mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="max-w-4xl mb-16 md:mb-20">
          <span className="text-gray-500 text-sm uppercase tracking-widest font-medium mb-4 block">
            {operationsData.subtitle}
          </span>
          <h2 className="text-black text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase">
            {operationsData.title}
          </h2>
        </div>

        {/* Operations Grid */}
        <div className="grid md:grid-cols-2 gap-px bg-gray-200">
          {operationsData.sections.map((section, index) => {
            const IconComponent = iconMap[section.icon];
            return (
              <div
                key={section.id}
                className="bg-white p-8 md:p-12 lg:p-16 group hover:bg-gray-50 transition-colors duration-300"
              >
                {/* Icon */}
                <div className="mb-8">
                  <div className="inline-flex items-center justify-center w-16 h-16 border border-gray-300 group-hover:border-black transition-colors">
                    {IconComponent && (
                      <IconComponent className="w-8 h-8 text-black" strokeWidth={1.5} />
                    )}
                  </div>
                </div>

                {/* Number */}
                <span className="text-gray-400 text-sm font-mono mb-4 block">
                  [{String(index + 1).padStart(2, '0')}]
                </span>

                {/* Title */}
                <h3 className="text-black text-2xl md:text-3xl font-bold uppercase tracking-wide mb-4">
                  {section.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-lg leading-relaxed">
                  {section.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OperationsSection;
